import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicEventFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 .8c0-.17.13-.3.3-.3h.9c.17 0 .3.13.3.3V2h5V.8c0-.17.13-.3.3-.3h.9c.17 0 .3.13.3.3V2h.5c.83 0 1.5.67 1.5 1.5V5H1V3.5C1 2.67 1.67 2 2.5 2H3V.8zM1 6.2v5.3c0 .83.67 1.5 1.5 1.5h4.1a5.02 5.02 0 014.9-6 5 5 0 011.5.23V6.2H1zM15.5 12a4 4 0 11-8 0 4 4 0 018 0zm-3.82-2.36l.67 1.28 1.38.28a.2.2 0 01.11.32l-.97 1.1.18 1.46a.2.2 0 01-.29.2l-1.26-.62-1.26.62a.2.2 0 01-.28-.2l.17-1.47-.97-1.09a.2.2 0 01.11-.32l1.38-.28.67-1.28a.2.2 0 01.36 0z"
      />
    </svg>
  );
}

SvgBasicEventFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicEventFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicEventFilled svgRef={ref} {...props} />
));
export default ForwardRef;
